
/* ===== VELANTIS_CARD_OPEN — abre la ficha desde cualquier tarjeta .card ===== */
(function(){
  var ov=document.getElementById('pvOverlay'); if(!ov) return;
  var CAT=window.VELANTIS_CAT||[];
  function de(s){return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();}
  var byName={}; CAT.forEach(function(r){ byName[de(r[0])]=r; });

  function fallbackOpen(card){
    var name=card.getAttribute('data-name')||'';
    var sub=card.getAttribute('data-sub')||'';
    var img=card.getAttribute('data-img')||'';
    var insp=((card.querySelector('.insp')||{}).textContent||'');
    var house=''; var parts=insp.split('·'); if(parts.length>1) house=parts[parts.length-1].trim();
    var pv=ov.querySelector('.pv');
    pv.dataset.name=name; pv.dataset.price='389'; pv.dataset.img=img; pv.dataset.sub=sub;
    var im=document.getElementById('pvImg'); im.className='pv-img '+img;
    document.getElementById('pvFam').textContent=sub;
    document.getElementById('pvName').textContent=name;
    var hEl=document.getElementById('pvHouse');
    hEl.textContent=house?('Inspirado en · '+house):''; hEl.hidden=!house;
    document.getElementById('pvDesc').textContent=
      (sub?('Fragancia de familia '+sub.toLowerCase()+'. '):'')+
      'Elixir de Parfum de alta concentración y larga duración.';
    document.getElementById('pvPyr').innerHTML='';
    ov.classList.add('show'); document.body.style.overflow='hidden';
  }

  function openCard(card){
    var r=byName[de(card.getAttribute('data-name')||'')];
    if(r && window.VelantisCatalogo && window.VelantisCatalogo.openByName){
      if(window.VelantisCatalogo.openByName(r[0])) return;
    }
    fallbackOpen(card);
  }

  function handle(target){
    if(target.closest('.add')) return;                 // el botón agrega al carrito
    var card=target.closest('.card');                  // .card (no .cat-card, que ya se maneja)
    if(!card || !card.getAttribute('data-name')) return;
    openCard(card);
  }
  document.addEventListener('click',function(e){ handle(e.target); });
  document.addEventListener('keydown',function(e){ if(e.key==='Enter') handle(e.target); });
})();
